import React, { useEffect } from "react";
import useStore from "../Zustand/Zustand";
import ZustandValidationConjugue from "../Zustand/ZustandValidationConjugue";
import ZustandValidationProponente from "../Zustand/ZustandFormProponent";
import ZustandFormImovel from "../Zustand/ZustandFormImovel";
import ZustandDadosDeFinanciamento from "../Zustand/ZustandDadosDeFinanciamento";
import ZustandSelectBankType from "../Zustand/ZustandSelectBankType";
import ZustandProductCgi from "../Zustand/ZustandProductCgi";
import MultiBanksApi from "./MultiBanksApi";
import InterFinApi from "./InterFinApi";
import { InterCgiApi } from "./InterCgiApi";
import ZustandFinancingBank from "../Zustand/ZustandFinancingBanks";
import ZustandAlert from "../Zustand/ZustandAlert";
import BitrixFunilApi from "./BitrixFunilApi";

const SimulationApi = ({
  tipoImovel,
  estadoImovel,
  situacaoImovel,
  valorImovel,
  valorFinanciamento,
  conjugeNome,
  conjugeRenda,
  conjugeDataNascimento,
  valorEntrada,
  valorFGTS,
  prazo,
  nome,
  dataNascimento,
  cpf,
  renda,
  email,
  totalRendaCasal,
  proponenteNome,
  proponenteRenda,
  proponenteDataNascimento,
  proponenteNome2,
  proponenteRenda2,
  proponenteDataNascimento2,
  totalRendaProponentes,
  totalRendaSimulacao,
  telefone,
  id,
}) => {
  const { selectInter, setDisableSelectdInter, taxInterIsSelect } =
    ZustandSelectBankType();

  const { triggerInvalid } = ZustandAlert();

  const {
    managerErro,
    setNomeCompletoIsErro,
    setEmailPrincipalIsErro,
    setNascimentoIsErro,
    setCpfIsErro,
    setRendaMensalIsErro,
    setNumeroIsErro,
    setLoading,
    adicionarSimulacao,
    numero,
    simulacoes,
    linkSimulacao,
    nomeCompleto,
  } = useStore();

  const {
    setnomeConjugueIsErro,
    setNascimentoConjugueIsErro,
    setRendaConjugueIsErro,
    buttonIsAtivo,
    nomeConjugue,
    rendaConjugue,
    nascimentoConjugue,
    secondErro,
  } = ZustandValidationConjugue();

  const {
    nomeProponente,
    rendaProponente,
    nascimentoProponente,
    proponentErro,
    setNomeProponenteIsErro,
    setNascimentoProponenteIsErro,
    setRendaProponenteIsErro,
    buttonIsAtivoProponent,
  } = ZustandValidationProponente();

  const {
    valorDoImovel,
    valorDeEntrada,
    prazoMeses,
    setValorDoImovelIsErro,
    setValorEntradaIsErro,
    setPrazoMesesIsErro,
    imovelErro,
  } = ZustandFormImovel();

  const {
    taxaBrb,
    taxaBradesco,
    taxaCaixa,
    taxaInter,
    taxaSantander,
    taxaItau,
  } = ZustandDadosDeFinanciamento();

  const {
    valorEmprestimo,
    cgi,
    prazoMesesCgi,
    setPrazoMesesCgiIsErro,
    setValorEmprestimoIsErro,
    imovelCgiIsErro,
    valorImovelCgi,
    setValorDoImovelCgiIsErro,
  } = ZustandProductCgi();

  const {
    buttonTaxItauIsSelect,
    setButtonTaxItauIsSelect,
    buttonTaxBradescoIsSelect,
    setButtonTaxBradescoIsSelect,
    buttonTaxCaixaIsSelect,
    setButtonTaxCaixaIsSelect,
    buttonTaxInterIsSelect,
    setButtonTaxInterIsSelect,
    buttonTaxSantanderIsSelect,
    setButtonTaxSantanderIsSelect,
    buttonTaxBrbIsSelect,
    setButtonTaxBrbIsSelect,
    setButtonTaxIsErro,
  } = ZustandFinancingBank();


  useEffect(() => {
    if (linkSimulacao) {
      console.log("Data " + dataNascimento)
      BitrixFunilApi({
        nomeCompleto,
        cpf,
        dataNascimento,
        email,
        telefone,
        linkSimulacao,
        cgi,
        valorImovel,
        valorFinanciamento,
      });
    }
  }, [linkSimulacao]);
  



  async function bitrixFin() {
    let linkSimulacao = ""
    {
      BitrixFunilApi({
        nomeCompleto,
        cpf,
        dataNascimento,
        email,
        telefone,
        linkSimulacao,
        cgi,
        valorImovel,
        valorFinanciamento,
      });
    }
  }
  async function BitrixFunilCgi() {

    const valorImovel = valorImovelCgi
    const valorFinanciamento = valorEmprestimo
    let linkSimulacao = ""

    {
      BitrixFunilApi({
        nomeCompleto,
        cpf,
        dataNascimento,
        email,
        telefone,
        linkSimulacao,
        cgi,
        valorImovel,
        valorFinanciamento,
      });
    }
  }


  const verificarSelecaoDosBancos = () => {
    const nenhumBotaoSelecionado =
      !buttonTaxItauIsSelect &&
      !buttonTaxBradescoIsSelect &&
      !buttonTaxCaixaIsSelect &&
      !buttonTaxInterIsSelect &&
      !buttonTaxSantanderIsSelect &&
      !buttonTaxBrbIsSelect;

    const nenhumaTaxaSelecionada =
      taxaBrb == 0 &&
      taxaBradesco == 0 &&
      taxaCaixa == 0 &&
      taxaInter == 0 &&
      taxaSantander == 0 &&
      taxaItau == 0;

    if (nenhumBotaoSelecionado && nenhumaTaxaSelecionada) {
      setButtonTaxIsErro(true);
      triggerInvalid();
      return false;
    }

    setButtonTaxIsErro(false);
    return true;
  };

  function ValidadeForm() {
    let hasError = false;

    if (nome === "") {
      setNomeCompletoIsErro(true);
      triggerInvalid();
      hasError = true;
    } else {
      setNomeCompletoIsErro(false);
    }

    if (email === "") {
      setEmailPrincipalIsErro(true);
      triggerInvalid();

      hasError = true;
    } else {
      setEmailPrincipalIsErro(false);
    }

    if (dataNascimento === "") {
      setNascimentoIsErro(true);
      triggerInvalid();

      hasError = true;
    } else {
      setNascimentoIsErro(false);
    }

    if (cpf === "") {
      setCpfIsErro(true);
      triggerInvalid();

      hasError = true;
    } else {
      setCpfIsErro(false);
    }

    if (renda == "0") {
      setRendaMensalIsErro(true);
      triggerInvalid();

      hasError = true;
    } else {
      setRendaMensalIsErro(false);
    }

    if (numero === "") {
      setNumeroIsErro(true);
      triggerInvalid();

      hasError = true;
    } else {
      setNumeroIsErro(false);
    }

    return !hasError;
  }
  function ValidadeSecondForm() {
    if (buttonIsAtivo) {
      let hasError = false;
      if (nomeConjugue === "") {
        setnomeConjugueIsErro(true);
        triggerInvalid();

        hasError = true;
      } else {
        setnomeConjugueIsErro(false);
      }

      if (nascimentoConjugue === "") {
        setNascimentoConjugueIsErro(true);
        triggerInvalid();

        hasError = true;
      } else {
        setNascimentoConjugueIsErro(false);
      }

      if (rendaConjugue == "0") {
        setRendaConjugueIsErro(true);
        triggerInvalid();

        hasError = true;
      } else {
        setRendaConjugueIsErro(false);
      }
      return !hasError;
    }
    if (buttonIsAtivo == false) {
      return true;
    }
  }
  function ValidationProponentForm() {
    if (buttonIsAtivoProponent) {
      let hasError = false;
      if (nomeProponente === "") {
        setNomeProponenteIsErro(true);
        triggerInvalid();

        hasError = true;
      } else {
        setNomeProponenteIsErro(false);
      }

      if (nascimentoProponente === "") {
        setNascimentoProponenteIsErro(true);
        triggerInvalid();

        hasError = true;
      } else {
        setNascimentoProponenteIsErro(false);
      }

      if (rendaProponente == "0") {
        setRendaProponenteIsErro(true);
        triggerInvalid();

        hasError = true;
      } else {
        setRendaProponenteIsErro(false);
      }
      return !hasError;
    }
    if (buttonIsAtivoProponent == false) {
      return true;
    }
  }
  function ValidationImovel() {
    let hasError = false;
    if (valorDeEntrada == 0 && valorFGTS == 0) {
      setValorEntradaIsErro(true);
      triggerInvalid();

      hasError = true;
    } else {
      setValorEntradaIsErro(false);
    }

    if (prazoMeses == 0) {
      setPrazoMesesIsErro(true);
      triggerInvalid();

      hasError = true;
    } else {
      setPrazoMesesIsErro(false);
    }

    if (valorDoImovel == 0) {
      setValorDoImovelIsErro(true);
      triggerInvalid();

      hasError = true;
    } else {
      setValorDoImovelIsErro(false);
    }
    return !hasError;
  }

  function ValidationImovelCgi() {
    let hasError = false;

    if (valorEmprestimo == 0) {
      setValorEmprestimoIsErro(true);
      triggerInvalid();

      hasError = true;
    } else {
      setValorEmprestimoIsErro(false);
    }

    if (prazoMesesCgi == 0) {
      setPrazoMesesCgiIsErro(true);
      triggerInvalid();

      hasError = true;
    } else {
      setPrazoMesesCgiIsErro(false);
    }

    if (valorImovelCgi == 0) {
      setValorDoImovelCgiIsErro(true);
      triggerInvalid();

      hasError = true;
    } else {
      setValorDoImovelCgiIsErro(false);
    }
    return !hasError;
  }

  function alertDialog() {
    if (managerErro || secondErro || proponentErro || imovelErro) {
      triggerInvalid();
      return false;
    } else {
      return true;
    }
  }
  function alertDialogCGI() {
    if (managerErro || secondErro || proponentErro || imovelCgiIsErro) {
      triggerInvalid();
      return false;
    } else {
      return true;
    }
  }

  return (
    <div>
      {cgi == "CGI" ? (
        <button
          className="simulation-button"
          onClick={() => {
            if (managerErro === true && ValidadeForm() === false) {
              window.scrollTo({
                top: 3,
                behavior: "smooth",
              });
              return;
            }
            if (secondErro === true && ValidadeSecondForm() === false) {
              window.scrollTo({
                top: 9,
                behavior: "smooth",
              });
              return;
            }
            if (proponentErro === true && ValidationProponentForm() === false) {
              window.scrollTo({
                top: 9,
                behavior: "smooth",
              });
              return;
            }
            if (
              alertDialogCGI() &&
              !managerErro &&
              ValidadeForm() &&
              !secondErro &&
              ValidadeSecondForm() &&
              !proponentErro &&
              ValidationProponentForm() &&
              !imovelCgiIsErro &&
              ValidationImovelCgi() &&
              verificarSelecaoDosBancos()
            ) {
              {
                {
                  setLoading(true);
                }
                {
                  InterCgiApi({
                    prazoMesesCgi,
                    valorEmprestimo,
                    valorImovelCgi,
                  });
                  {BitrixFunilCgi()}
                }
              }
            }
          }}
        >
          Simular
        </button>
      ) : (
        <button
          className="simulation-button"
          onClick={() => {
            if (managerErro === true && ValidadeForm() === false) {
              window.scrollTo({
                top: 3,
                behavior: "smooth",
              });
              return;
            }
            if (secondErro === true && ValidadeSecondForm() === false) {
              window.scrollTo({
                top: 9,
                behavior: "smooth",
              });
              return;
            }
            if (proponentErro === true && ValidationProponentForm() === false) {
              window.scrollTo({
                top: 9,
                behavior: "smooth",
              });
              return;
            }
            if (
              alertDialog() &&
              !managerErro &&
              ValidadeForm() &&
              !secondErro &&
              ValidadeSecondForm() &&
              !proponentErro &&
              ValidationProponentForm() &&
              !imovelErro &&
              ValidationImovel() &&
              verificarSelecaoDosBancos()
            ) {
              {
                selectInter === "Multibancos" ? (
                  <>
                    {setLoading(true)}
                    {MultiBanksApi({
                      tipoImovel,
                      estadoImovel,
                      situacaoImovel,
                      valorImovel,
                      valorFinanciamento,
                      valorEntrada,
                      valorFGTS,
                      prazo,
                      nome,
                      dataNascimento,
                      cpf,
                      renda,
                      email,
                      conjugeNome,
                      conjugeRenda,
                      totalRendaCasal,
                      conjugeDataNascimento,
                      proponenteNome,
                      proponenteRenda,
                      proponenteDataNascimento,
                      proponenteNome2,
                      proponenteRenda2,
                      proponenteDataNascimento2,
                      totalRendaProponentes,
                      totalRendaSimulacao,
                      id,
                      telefone,
                      taxaBrb,
                      taxaBradesco,
                      taxaCaixa,
                      taxaInter,
                      taxaSantander,
                      taxaItau,
                      adicionarSimulacao,
                      setLoading,
                      setDisableSelectdInter,
                    })}
                  </>
                ) : (
                  <>
                    {setLoading(true)}
                    {InterFinApi()}
                    {bitrixFin()}

                  </>
                );
              }
            }
          }}
        >
          Simular
        </button>
      )}
    </div>
  );
};

export default SimulationApi;
